export default __webpack_public_path__ + "static/media/footer-logo.112dd142.svg";